import classNames from "classnames";
import { setExpertGroupContent } from "../../features/topic/ContentSideBarSlice";
import { getDitaContent } from "../Content/ContentSlice";
import styles from "./ExpertGroupPopup.module.scss";

function getExpertGroup(expertGroupList, topLevelGuideline, content, dispatch) {
  const expertGroupRows = expertGroupList.getElementsByTagName("relrow");
  let formattedExpertGroup = [];
  Array.from(expertGroupRows).forEach((row, rowIndex) => {
    Array.from(row.children[2].children).forEach((topic, topicIndex) => {
      if (topic.attributes.href.value.includes(topLevelGuideline)) {
        Array.from(row.children[0].children).forEach((childGroup, groupIndex) => {
          const url = childGroup.attributes.href.value;
          parseExpertGroupFiles(
            url,
            content,
            dispatch,
            formattedExpertGroup,
            `${rowIndex}-${topicIndex}-${groupIndex}`,
          );
        });
      }
    });
  });
  dispatch(setExpertGroupContent({ expertGroupContent: formattedExpertGroup.length > 0 }));
  return formattedExpertGroup;
}

function getExpertGroupFromUrl(url, content, dispatch) {
  let formattedExpertGroup = [];
  parseExpertGroupFiles(url, content, dispatch, formattedExpertGroup, "expert-group");
  return formattedExpertGroup;
}

function parseExpertGroupFiles(url, content, dispatch, formattedExpertGroup, keyPrefix) {
  const formattedUrl = url.startsWith("Contributors/") ? url : "Contributors/" + url;
  const expertGroup = getDitaContent(formattedUrl, content, dispatch);
  if (expertGroup) {
    const title =
      expertGroup?.getElementsByTagName("title")[0] ??
      expertGroup?.getElementsByTagName("ditatitle")[0];
    if (title) {
      formattedExpertGroup.push(
        <div
          key={`${keyPrefix}-title`}
          className={classNames("size-20 semibold", styles.expertGroupTitle)}
        >
          {title.textContent}
        </div>,
      );
    }
    const standardClause = expertGroup?.getElementsByTagName("p")[0];
    if (standardClause) {
      formattedExpertGroup.push(
        <div
          className={classNames("size-14 medium", styles.standardClause)}
          dangerouslySetInnerHTML={{ __html: standardClause.innerHTML }}
        />,
      );
    }
    const expertProfile = expertGroup.getElementsByTagName("section");
    getExpertGroupInfo(expertProfile, formattedExpertGroup, keyPrefix);
  }
  return expertGroup;
}

function getExpertGroupInfo(expertProfile, formattedExpertGroup, keyPrefix) {
  Array.from(expertProfile).forEach((expertSection, sectionIndex) => {
    Array.from(expertSection.children).forEach((expertLine, lineIndex) => {
      // Need to check both node names
      // ccms online version shows up title
      // hydrated version shows up ditatitle
      if (expertLine.nodeName === "title" || expertLine.nodeName === "ditatitle") {
        formattedExpertGroup.push(
          <div key={`${keyPrefix}-${sectionIndex}-${lineIndex}-title`} className="size-16 bold">
            {expertLine.textContent}
          </div>,
        );
      } else if (expertLine.nodeName === "div") {
        const childLines = [];
        Array.from(expertLine.children).forEach((expertChildLine, childIndex) => {
          childLines.push(
            <li key={`${keyPrefix}-${sectionIndex}-${lineIndex}-${childIndex}`}>
              {expertChildLine.textContent}
            </li>,
          );
        });
        formattedExpertGroup.push(
          <div
            key={`${keyPrefix}-${sectionIndex}-${lineIndex}-div`}
            className={classNames("size-14 medium", styles.contributorText)}
          >
            {childLines}
          </div>,
        );
      } else if (expertLine.nodeName === "p") {
        formattedExpertGroup.push(
          <div
            key={`${keyPrefix}-${sectionIndex}-${lineIndex}-p`}
            className="size-14 medium"
            dangerouslySetInnerHTML={{ __html: expertLine.innerHTML }}
          ></div>,
        );
      }
    });
  });
}

export { getExpertGroup, getExpertGroupFromUrl };
